import { FieldDelimiter } from '../../fields';
import {
  InputLayoutModel,
  ProductInputModel,
  ProgramMetadataModel,
  ProgramStatus,
} from '../common';

export const DefaultValidationThresholdValue = 95;
export const DefaultPinningThresholdValue = 95;

export interface ThresholdsModel {
  validationThreshold: number;
  pinningThreshold: number;
}

export interface FrontEndProcessingModel {
  clientInputFileName: string;
  experianInputFileName: string;
  inputQuantity?: number;
  inputHeader?: boolean;
  inputFormat: string;
  inputDelim: FieldDelimiter;
  thresholds: ThresholdsModel;
  inputLayout: Array<InputLayoutModel>;
  intentType?: string;
}

export interface PackagesInputModel {
  frontEndProcessing: FrontEndProcessingModel;
}

export interface AscendArchivesProgramV1 {
  status?: ProgramStatus;
  externalSystemRef?: string;
  subCode?: string;
  programKey?: string;
  metadata: ProgramMetadataModel;
  productInput: ProductInputModel;
  packagesInput: PackagesInputModel;
  dataDictionaryVersion?: string;
}

export type AscendArchivesProgram = AscendArchivesProgramV1;
